module.exports = __webpack_public_path__ + "static/08_olena_malynska-5e4d5aead5b75095bbad5a3016a7c3f3.jpg";